import { TrainingResourceType } from "@src/types.generated";

export const RESOURCE_TYPE_FILTER_LABELS: Record<TrainingResourceType, string> =
  {
    [TrainingResourceType.OpusDoc]: "Opus Doc",
    [TrainingResourceType.Video]: "Video",
    [TrainingResourceType.Image]: "Image",
    [TrainingResourceType.Pdf]: "PDF",
    [TrainingResourceType.Audio]: "Audio",
    [TrainingResourceType.Gif]: "Gif",
    [TrainingResourceType.Website]: "Website",
    [TrainingResourceType.ContactCard]: "Contact Card",
    [TrainingResourceType.Link]: "Link",
  };

export const RESOURCE_TYPE_FILTER_OPTIONS: TrainingResourceType[] = [
  TrainingResourceType.OpusDoc,
  TrainingResourceType.Video,
  TrainingResourceType.Image,
  TrainingResourceType.Pdf,
  TrainingResourceType.Audio,
  TrainingResourceType.Gif,
  TrainingResourceType.Website,
  TrainingResourceType.ContactCard,
  TrainingResourceType.Link,
];
